import React from 'react';
import PropTypes from 'prop-types';
import { IconSavedBed, IconSavedWall } from '../Icons';
import { getVisualizerNoun } from '../../Utils/VisualizerUtils';
import { StyledFlexWrapper, StyledPinkOutlineButton } from './VisualizerSaveModalStyles';

var _ref2 = React.createElement(IconSavedWall, null);

var _ref3 = React.createElement(IconSavedBed, null);

var VisualizerSaveSucces = function VisualizerSaveSucces(_ref) {
  var title = _ref.title,
      closeModalFunc = _ref.closeModalFunc,
      isWallGallery = _ref.isWallGallery;

  var visualzerNoun = getVisualizerNoun();
  return React.createElement(
    StyledFlexWrapper,
    { component: 'VisualizerSaveSucces' },
    isWallGallery ? _ref2 : _ref3,
    React.createElement(
      'h3',
      null,
      title,
      ' saved!'
    ),
    React.createElement(
      'h4',
      null,
      'You\'ve got great taste.'
    ),
    React.createElement(
      StyledPinkOutlineButton,
      { onClick: closeModalFunc },
      'Keep Editing This ' + visualzerNoun
    ),
    React.createElement(
      StyledPinkOutlineButton,
      { as: 'a', href: window.location.pathname },
      'Design A New ' + visualzerNoun
    )
  );
};

VisualizerSaveSucces.propTypes = {
  title: PropTypes.string,
  closeModalFunc: PropTypes.func,
  isWallGallery: PropTypes.bool
};

export default VisualizerSaveSucces;